import { useMemo } from 'react';

import { BudgetAlertProps } from './BudgetAlert';

export const useBudgetComparison = ({ budget, quotedValue }: BudgetAlertProps) => {
  return useMemo(() => {
    if (!budget || !quotedValue) {
      return { isQuotedValueOverBudget: null, difference: null };
    }

    return {
      isQuotedValueOverBudget: quotedValue.greaterThan(budget),
      difference: budget.minus(quotedValue).abs(),
    };
  }, [budget, quotedValue]);
};
